export enum SubmitStatus {
    Initial = 'initial',
    Success = 'done',
    Error = 'error',
}
